import { Component } from '@angular/core';
import {NgForOf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-info-imagenes',
  standalone: true,
  imports: [
    NgForOf,
    NgOptimizedImage
  ],
  templateUrl: './info-imagenes.component.html',
  styleUrl: './info-imagenes.component.css'
})
export class InfoImagenesComponent {

  services=[
    {
      "name": "Rayos X"
    },{
      "name": "Ecografía"
    },{
      "name": "Tomografía"
    },{
      "name": "Resonancia magnética"
    },{
      "name": "Angioresonancia"
    },{
      "name": "Urotac simple"
    },{
      "name": "Angiotac"
    },{
      "name": "Densitometría"
    },{
      "name": "Mamografía"
    },
  ]

}
